// extracted by mini-css-extract-plugin
export var customText = "r_qS d_dv d_cs d_cg";
export var videoIframeStyle = "r_p3 d_d5 d_w d_H d_by d_b1 d_R";
export var customImageWrapper = "r_qT d_cs d_cg d_Z";
export var customRow = "r_qn d_bD d_bf";
export var quoteWrapper = "r_gQ d_bC d_bP d_cs d_cg";
export var quoteBar = "r_p7 d_H";
export var masonryImageWrapper = "r_qf";
export var title = "r_qV";
export var Title3Small = "r_qW G_qW G_sX G_s4";
export var Title3Normal = "r_qX G_qX G_sX G_s5";
export var Title3Large = "r_qY G_qY G_sX G_s6";